import {companyFeaturesConstants} from '../../constants';
import {useCompanyFeatureAvailable} from './useCompanyFeatureAvailable';

const featureName = companyFeaturesConstants.PSD2_OB_AVAILABLE;

/**
 * Checks if the PSD2 open banking module is available for the company.
 *
 * @returns {boolean} True when the `psd2_ob_available` company feature is enabled.
 *
 * @example
 * const isPsd2ObAvailable = useIsPsd2ObAvailable();
 */
export const useIsPsd2ObAvailable = () => {
  return useCompanyFeatureAvailable(featureName);
};
